
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetojalanacab() {



    const cardData =
    {
        keyword: 'Pune To Jalana Cab',
        heading: 'Mauli Cabs:  Pune To Jalana Cab',
        headingDescription: 'Mauli Cabs offers reliable and convenient Pune to Jalna cab services, ensuring a smooth and comfortable journey to the city of Jalna. Whether you are traveling for business, a family visit, or exploring the local attractions, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Jalna.',

        top: 'Top Places to Visit in Nagpur with Mauli Cabs',

"topPlaces": [
    {
        "title": "Jalna Fort (Mastgad)",
        "description": "Built in 1725 by Kabil Khan under the orders of Nizam ul Mulk Asaf Jah I, Jalna Fort, also known as Mastgad, showcases Nizam-style architecture. Despite its partial collapse, it remains a significant historical site, housing a mosque and a Sufi saint's shrine."
    },
    {
        "title": "Matsyodari Devi Temple",
        "description": "Situated atop a hill shaped like a fish ('Matsya'), this temple is dedicated to Goddess Matsyodari. It's a revered pilgrimage site, especially during the annual fair held on the occasion of Ram Navami."
    },
    {
        "title": "Jamb Samartha (Jamb Samarth)",
        "description": "Located in Ghansawangi, this site marks the birthplace of Sant Ramdas Swami. The temple attracts thousands of devotees during the Ram Navami festival, reflecting its spiritual significance."
    },
    {
        "title": "Guru Ganesh Tapodham",
        "description": "This spiritual center in Jalna city is dedicated to Guru Ganesh, offering a serene environment for meditation and religious activities."
    },
    {
        "title": "Shree Ganesh Temple, Rajur",
        "description": "Approximately 25 km from Jalna, this temple is renowned for its grand Ganesh Chaturthi celebrations, drawing numerous devotees annually."
    },
    {
        "title": "Kali Masjid",
        "description": "Constructed in 1578 CE by the Nizam Shahi dynasty, Kali Masjid is an architectural marvel made of black stone. Its unique design and historical significance make it a notable landmark in Old Jalna."
    },
    {
        "title": "Chhatrapati Sambhaji Maharaj Park (Moti Bagh)",
        "description": "A popular recreational spot in Jalna, this park features a mini train, colorful water fountains, and lush greenery, making it ideal for family outings."
    },
    {
        "title": "Jalna Fort",
        "description": "A historical fort located on the eastern side of Jalna, built in 1725 by Kabil Khan under the orders of Nizam ul Mulk Asaf Jah I. The fort, along with the citadel, occupies a prominent position in the town."
    },
    {
        "title": "Gandhi Chaman",
        "description": "A tranquil garden in Jalna, Gandhi Chaman offers a peaceful environment for relaxation and leisurely walks."
    },
    {
        "title": "Neelam Cineplex",
        "description": "A popular cinema hall in Jalna, Neelam Cineplex screens the latest Bollywood and regional films, providing entertainment for movie enthusiasts."
    }
],

"services": [
    {
        "name": "Pune to Jalana Cab Service",
        "description": "Looking for a reliable and comfortable cab service from Pune to Jalana? Mauli Cabs provides smooth, stress-free, and affordable journeys. Book your ride today!"
    },
    {
        "name": "Book Pune to Jalana Taxi",
        "description": "Easily book your Pune to Jalana taxi with Mauli Cabs. Enjoy a hassle-free travel experience with our online booking system."
    },
    {
        "name": "Affordable Pune to Jalana Cab",
        "description": "Mauli Cabs offers affordable and competitive pricing for your Pune to Jalana trip without compromising on comfort and quality."
    },
    {
        "name": "Private Taxi for Jalana from Pune",
        "description": "Travel privately from Pune to Jalana with Mauli Cabs. Enjoy a personalized experience with our dedicated private taxis for a seamless journey."
    },
    {
        "name": "Jalana Trip by Cab from Pune",
        "description": "Planning a trip to Jalana? Travel comfortably and conveniently with Mauli Cabs for a smooth ride from Pune to Jalana."
    },
    {
        "name": "Pune to Jalana One-Way or Round Trip",
        "description": "Choose between one-way or round-trip options for your Pune to Jalana journey with Mauli Cabs, ensuring flexibility and convenience for your travel needs."
    },
    {
        "name": "Comfortable Taxi Ride to Jalana",
        "description": "Enjoy a comfortable and relaxing ride from Pune to Jalana with Mauli Cabs. Our well-maintained vehicles provide a smooth and pleasant experience."
    },
    {
        "name": "Group Travel to Jalana",
        "description": "Traveling with a group? Mauli Cabs offers spacious vehicles for group trips from Pune to Jalana, ensuring comfort for everyone."
    },
    {
        "name": "Luxury Taxi for Jalana Trip",
        "description": "For a more luxurious experience, choose Mauli Cabs' premium taxi services for your Pune to Jalana trip. Travel in comfort and style with our top-tier vehicles."
    },
    {
        "name": "Jalana Sightseeing by Taxi",
        "description": "Explore the attractions of Jalana with Mauli Cabs’ sightseeing tours. Sit back and relax as we take you to the best landmarks and tourist spots in the city."
    }
],

"tableData": [
    ["Pune to Jalana Cab Service", "Book Pune to Jalana Taxi"],
    ["Affordable Pune to Jalana Cab", "Private Taxi for Jalana from Pune"],
    ["Jalana Trip by Cab from Pune", "Pune to Jalana One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Jalana", "Group Travel to Jalana"],
    ["Luxury Taxi for Jalana Trip", "Jalana Sightseeing by Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for your Pune to Jalna Cab journey. Our professional drivers are dedicated to providing punctual pickups and drop-offs, ensuring that you reach Jalna on time for your work or leisure activities."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Jalna trip, we offer a variety of vehicles including sedans, SUVs, and premium cars. All our vehicles are well-maintained, air-conditioned, and spacious, providing you with a comfortable and enjoyable ride throughout your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the best routes to Jalna, ensuring a smooth, safe, and efficient journey. They are committed to making your trip hassle-free, allowing you to focus on the purpose of your visit."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Jalna Cab booking. We provide upfront pricing with no hidden charges, ensuring you get the best value for your money without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure a secure and pleasant journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Jalna trip. Whether you need an early morning ride or a late-night return, our customer service team is always available to assist you with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Jalna cab with Mauli Cabs is simple and convenient. You can book your ride online through our website or mobile app, or contact our customer service team for personalized assistance and a smooth booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Jalna trip. Whether you're traveling for business, leisure, or any specific purpose, we can tailor the trip to meet your specific needs and preferences."
    }
]
























    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Jalna with Mauli Cabs?',
            answer: 'Booking your cab for a trip from Pune to Jalna is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Jalna as your destination, then select the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Jalna trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Jalna, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Jalna trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. The total fare is provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Jalna take?',
            answer: 'The journey from Pune to Jalna typically takes around 6.5 to 7 hours, depending on traffic conditions. Our drivers ensure a smooth and comfortable journey, allowing for breaks along the way if needed.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Jalna route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Jalna route and are familiar with the best roads to ensure a safe and timely journey. They prioritize your comfort and safety throughout the trip.',
        },
        {
            question: 'Can I book a round trip for the Pune to Jalna trip?',
            answer: 'Yes, you can easily book a round trip to Jalna. Just provide your return details when making the booking, and we will ensure a smooth return journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Jalna?',
            answer: 'Yes, you can customize your trip by making stops for sightseeing or taking breaks along the way. Whether you want to visit popular spots or just rest during the journey, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride during your journey to Jalna.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Jalna trip?',
            answer: 'Mauli Cabs offers reliable service, competitive pricing, a wide range of vehicle options, and experienced drivers. We ensure that your trip to Jalna is smooth, comfortable, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Joshi",
            position: "Business Executive",
            text: "I traveled from Pune to Jalna with Mauli Cabs and had an excellent experience. The driver was punctual, the car was clean and comfortable, and the journey was smooth. I would definitely recommend Mauli Cabs for long-distance travel.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Patel",
            position: "Leisure Traveler",
            text: "My trip to Jalna was made easy and stress-free thanks to Mauli Cabs. The driver was polite and experienced, and the vehicle was very comfortable. The trip was pleasant, and I felt safe throughout. Highly recommend Mauli Cabs for your journey!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Jalana Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Jalana. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Jalana with 24x7 online booking support, perfect for sightseeing and exploring the area.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
    
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Jalana Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Jalana cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking, ideal for sightseeing in Jalana."
        />
        <meta
          name="keywords"
          content="Pune to Jalana cab service, Book Pune to Jalana taxi, Affordable Pune to Jalana cab, Private taxi for Jalana from Pune, Jalana trip by cab from Pune, Pune to Jalana one-way or round trip, Comfortable taxi ride to Jalana, Group travel to Jalana, Luxury taxi for Jalana trip, Jalana sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojalanacab;